import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { toast } from "react-toastify";
import { showApiErrorToast } from "../utils/helpers";

const updateVisitExternalPhotoTypes = async ({ visitId, ids, isAllExternalPhotos }) => {
  const token = localStorage.getItem("token");

  const payload = { external_photo_type_ids: ids };
  if (isAllExternalPhotos !== undefined) payload.is_all_external_photos = isAllExternalPhotos;

  const res = await axios.put(
    `${__API_URL__}/api/photos/visits/${visitId}/external-photo-types/`,
    payload,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return res.data;
};

const useUpdateVisitExternalPhotoTypesMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateVisitExternalPhotoTypes,
    onSuccess: () => {
      toast.success("External photo types updated");
      queryClient.invalidateQueries({ queryKey: ["visit_external_photo_types"] });
    },
    onError: (error) => {
      showApiErrorToast(error, "Failed to update external photo types");
    },
  });
};

export default useUpdateVisitExternalPhotoTypesMutation;
